import React from "react"

import {Details} from "@irati/checkout/utils/redemption"
import {ProductSalePrice} from "@irati/types"
import Button from "@irati/ui/src/Button"
import Flex from "@irati/ui/src/Flex"
import {H4} from "@irati/ui/src/Typography"
import {FormattedCurrency, FormattedMessage} from "@irati/utils/lang"
import {StyledSpecialOfferLabel} from "../containers/styled"
import {DealStatus} from "./DealStatus"

type Props = {
  onClick: () => void
  salePrice?: ProductSalePrice
  load?: Promise<Details> | null
  error?: Error | null
}

export const RedeemSection = ({salePrice, onClick, load, error}: Props) => (
  <section>
    <Flex wrap="wrap" alignItems="center">
      {salePrice ? (
        <H4 weight="bold" marginRight={1} padding={[1, 0]}>
          <FormattedCurrency isCents={false} value={salePrice?.value} currency={salePrice?.currency} />
        </H4>
      ) : null}
      <DealStatus err={error} />
    </Flex>

    <StyledSpecialOfferLabel />

    <Button primary full onClick={onClick} load={load} marginTop={3}>
      <FormattedMessage id="flexiRewards.merchandise.info.cta" />
    </Button>
  </section>
)
